
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">
              Golden Twin Towers
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('brands')}
              className="text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
            >
              Brands
            </button>
            <button 
              onClick={() => scrollToSection('oem-odm')}
              className="text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
            >
              OEM/ODM
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
            >
              About Us
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              size="sm"
            >
              Contact
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4 pt-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-left text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('brands')}
                className="text-left text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
              >
                Brands
              </button>
              <button 
                onClick={() => scrollToSection('oem-odm')}
                className="text-left text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
              >
                OEM/ODM
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-left text-gray-700 hover:text-[#C8A654] transition-colors cursor-pointer"
              >
                About Us
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                size="sm"
                className="self-start"
              >
                Contact
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
